var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardSwipable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2716 6.33373C24.6402 5.17103 23.4825 4.82231 22.6054 5.40356L8.71291 14.5496C7.9411 15.0535 7.62543 16.061 7.97606 17.0685C6.74806 17.9211 4.78353 26.2145 4.78353 26.2145L3.06444 27.7645C2.67853 28.1133 2.57331 28.6947 2.74876 29.1984L5.76582 35.3992C6.01151 35.9418 6.60785 36.1356 7.099 35.9031C8.04628 35.4768 9.58996 34.818 11.0281 34.5855C12.1156 34.3917 13.4489 33.229 13.6943 32.9192C14.3959 31.9891 21.5527 22.2618 21.5527 22.2618C22.2543 21.2929 22.0788 19.8202 21.1668 19.1227C20.3247 18.464 19.132 18.6964 18.4654 19.5877L15.0974 24.1996C14.5713 24.897 13.589 24.8197 13.1678 24.0447L11.4137 20.7504L26.2885 10.9843L29.2706 16.565C29.4461 16.8751 29.3408 17.2624 29.0602 17.4176L23.3769 21.1381V21.2157C23.3769 21.6807 23.2367 22.1846 22.9208 22.5723L19.4476 27.3003L19.5528 27.4941C19.9037 28.1916 20.7455 28.463 21.3772 28.0367L21.5876 27.9204C22.219 27.5328 22.4997 26.6802 22.3245 25.944C22.4647 25.9827 22.6401 26.0216 22.7806 26.0216C23.0613 26.0216 23.3067 25.944 23.5524 25.7891C24.2893 25.3242 24.5697 24.2777 24.1488 23.4251C24.289 23.4638 24.4645 23.5027 24.6049 23.5027C24.8506 23.5027 25.131 23.4251 25.3767 23.2702C26.0783 22.8439 26.359 21.8751 26.0433 21.1L29.762 18.6584C30.639 18.0772 30.9197 16.7983 30.5338 16.0619L25.2716 6.33373ZM9.9758 18.115L9.16898 16.6423C8.99352 16.3322 9.09874 15.9449 9.37943 15.7897L23.2719 6.6437C23.5526 6.44987 23.9033 6.56611 24.0437 6.87618L24.8506 8.34891L9.9758 18.115Z",
    fill: "url(#paint0_linear_3414_10044)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1488 18.3477L26.7449 16.6424C27.0256 16.4486 27.0958 16.0999 26.9554 15.7899L26.0783 14.1236C25.9029 13.8135 25.5872 13.7359 25.3065 13.8911L22.7104 15.5963C22.4297 15.7902 22.3595 16.1389 22.4999 16.4489L23.377 18.1152C23.5174 18.425 23.8681 18.5413 24.1488 18.3477Z",
    fill: "url(#paint1_linear_3414_10044)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4114 7.38052C29.236 7.30294 29.0605 7.41918 29.0255 7.613L28.8151 8.38802C28.7801 8.54292 28.8501 8.73675 28.9905 8.77568C29.3764 8.9695 29.7274 9.27957 29.9728 9.74454C30.2185 10.1708 30.2885 10.6747 30.2885 11.1397C30.2885 11.2946 30.3937 11.4498 30.5342 11.4884L31.2358 11.6433C31.4112 11.682 31.5867 11.5657 31.5867 11.3332C31.6569 10.5193 31.5165 9.70557 31.0956 8.96923C30.6744 8.23311 30.0781 7.69056 29.4114 7.38052Z",
    fill: "url(#paint2_linear_3414_10044)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0428 5.01626C29.8673 4.93868 29.6919 5.05492 29.6569 5.24875L29.4464 6.02376C29.4114 6.17866 29.4814 6.37249 29.6219 6.45008C30.5339 6.83773 31.3058 7.5352 31.8321 8.50406C32.3582 9.47292 32.5337 10.5967 32.4285 11.6431C32.3935 11.8369 32.4987 11.9918 32.6742 12.0307L33.3757 12.1856C33.5512 12.2243 33.7267 12.1081 33.7267 11.9142C33.9021 10.5191 33.6564 9.08523 32.9898 7.80634C32.288 6.41146 31.2355 5.51986 30.0428 5.01626Z",
    fill: "url(#paint3_linear_3414_10044)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8842 6.45024C33.9019 4.62878 32.3933 3.31121 30.6745 2.69107C30.499 2.61348 30.3588 2.72972 30.2885 2.92355L30.0781 3.69857C30.0431 3.85347 30.1131 4.0473 30.2885 4.12488C31.6917 4.66743 32.9197 5.75256 33.7617 7.26391C34.5686 8.77533 34.8492 10.4805 34.6038 12.1082C34.5688 12.302 34.674 12.4569 34.8495 12.4959L35.551 12.6508C35.7265 12.6894 35.8667 12.5732 35.902 12.3793C36.1824 10.3643 35.8668 8.27176 34.8842 6.45024Z",
    fill: "url(#paint4_linear_3414_10044)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3414_10044",
    x1: 2.6665,
    y1: 20.5636,
    x2: 30.7031,
    y2: 20.5636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3414_10044",
    x1: 22.4297,
    y1: 16.1279,
    x2: 27.0256,
    y2: 16.1279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3414_10044",
    x1: 28.8062,
    y1: 9.50342,
    x2: 31.604,
    y2: 9.50342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3414_10044",
    x1: 29.4375,
    y1: 8.59249,
    x2: 33.7815,
    y2: 8.59249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3414_10044",
    x1: 30.0693,
    y1: 7.66245,
    x2: 36,
    y2: 7.66245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardSwipable);
export default __webpack_public_path__ + "static/media/CardSwipable.176be298a724d80c7e195e588e6b231f.svg";
export { ForwardRef as ReactComponent };